import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'

export const getUserInfoService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'user/user-detail', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const storeErrorService = data => {
  return axiosInstanceService(METHOD_TYPES.post, 'user/store-error', data, {
    server: microServices.USER_URL,
    loader: null
  })
}
